import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { createFileRoute, type ErrorComponentProps, Outlet, redirect } from "@tanstack/react-router";
import { ensureDexieConfig } from "~/dexie/sync";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent,
  beforeLoad: async ({ context: { session } }) => {
    if (!session) {
      throw redirect({ to: "/login" });
    }

    await ensureDexieConfig();
    return { session };
  },
  errorComponent: ConfigBootstrapError,
});

function RouteComponent() {
  return <Outlet />;
}

function ConfigBootstrapError({ reset }: ErrorComponentProps) {
  return (
    <Center h="100dvh">
      <Stack align="center" gap="md">
        <Title order={3}>Unable to load application configuration</Title>
        <Text c="dimmed">Check your connection and try again.</Text>
        <Button onClick={reset}>Retry</Button>
      </Stack>
    </Center>
  );
}
